import { Link } from "react-router-dom";
import StickyNavbar from "../navbar";
import QuizPopup from "./QuizPopup";
import React, { useState } from "react";
import { motion } from "framer-motion";
import example1 from "../images/example1.svg";
import median from "../images/median.svg";
import mode from "../images/mode.svg";
import percent from "../images/percent.svg";

const DataCollection = () => {
  const [showQuiz, setShowQuiz] = useState(false);

  const handleQuizComplete = (answers) => {
    console.log("User answers:", answers);
    // You can process the answers here
  };

  return (
    <div>
      <StickyNavbar />
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="bg-white text-black p-4 lg:mt-10 mt-20 lg:text-lg sm:p-10 lg:px-20"
      >
        {/* First Data Analysis Section */}
        {/* <motion.div
          initial={{ y: -50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="space-y-3"
        >
          <h2 className="text-xl font-bold mb-2 text-[#005FFF] my-10">Data Analysis</h2>
          <p>
            Once you’ve collected your data, the next step is to make sense of it
            and what it means. This is where data analysis comes in. This means to
            organise and summarise it to help you spot patterns and themes, with the
            goal of being to answer your research questions. Using different ways of
            analysing your data helps to make the information manageable, clear and
            useful to others. (88)
          </p>
          <motion.ul
            initial={{ x: -20, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
            className="list-disc list-inside space-y-3"
          >
            <li>Descriptive statistics</li>
            <li>Data visualization</li>
          </motion.ul>
          <motion.ul
            initial={{ x: 20, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
            className="list-decimal list-inside space-y-3"
          >
            <li>Charts</li>
            <li>Graphs</li>
            <li>Tables</li>
          </motion.ul>
          <motion.li
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
          >
            Data presentation
          </motion.li>
          <p>
            Once you’ve collected your data, the next step is to make sense of it and
            what it means. This is where data analysis comes in. This means to organize
            and summarize it to help you spot patterns and themes, with the goal of being
            to answer your research questions. Using different ways of analyzing your
            data helps to make the information manageable, clear and useful to others.
            (88)
          </p>
        </motion.div> */}

        {/* Second Data Analysis Section with Images */}
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="space-y-3 mt-10"
        >
          <h2 className="text-xl font-bold mb-2 text-[#005FFF]">Data Analysis</h2>
          <p>
            Once you’ve collected your data, the next step is to make sense of it
            and what it means. This is where data analysis comes in. This means to
            organise and summarise it to help you spot patterns and themes, with the
            goal of being to answer your research questions. Using different ways of
            analysing your data helps to make the information manageable, clear and
            useful to others. (88)
          </p>
          <motion.h3
            initial={{ x: -30, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
            className="text-lg font-bold text-[#005FFF]"
          >
            Descriptive Statistics
          </motion.h3>
          <p>
            Using descriptive statistics is a simple way of laying out your data in the
            form of numbers. A statistic is something which you calculate using the data
            you have collected, that you can use to summarise it. Statistics help us to see
            the main patterns in the information. For example:
          </p>
          <motion.ul
            initial={{ x: -20, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
            className="list-disc list-inside space-y-3"
          >
            <li>
              <strong>Mean:</strong> This is a common statistic, or number, that can be
              worked out so we can see what is “typical” of the information or data. The
              mean is another word used for the average.
            </li>
            <motion.img
              src={example1}
              alt="Example for Mean"
              className="mx-auto w-2/3"
              initial={{ scale: 0.8, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.6 }}
            />
            <li>
              <strong>Median:</strong> This is a statistic to describe or show what the
              middle of a set of data is, in number form.
            </li>
            <motion.img
              src={median}
              alt="Example for Median"
              className="mx-auto w-2/3"
              initial={{ scale: 0.8, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.6 }}
            />
            <li>
              <strong>Mode:</strong> This is a statistic which tells us the most common
              value in our data; the mode is the number that appears most often in the data.
            </li>
            <motion.img
              src={mode}
              alt="Example for Mode"
              className="mx-auto w-2/3"
              initial={{ scale: 0.8, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.6 }}
            />
            <li>
              <strong>Percentages:</strong> Working out percentages is helpful when we
              want to work out proportions or better understand the different parts of
              all of your data.
            </li>
            <motion.img
              src={percent}
              alt="Example for Percentages"
              className="mx-auto w-2/3"
              initial={{ scale: 0.8, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.6 }}
            />
          </motion.ul>
        </motion.div>

        {/* Navigation Buttons */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="flex justify-between mt-10"
        >
          <Link to="/chapter5/data">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-blue-900 text-white px-3 py-2 rounded-lg hover:bg-blue-700"
            >
              Previous
            </motion.button>
          </Link>
          <div className="flex justify-center">
            {/* Uncomment to add quiz button */}
            {/* <motion.button
              onClick={() => setShowQuiz(true)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-white text-blue-800 border border-blue-800 px-3 py-2 rounded-lg"
            >
              Test Your Knowledge
            </motion.button> */}
          </div>
          <Link to="/chapter5/sectionThree">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-blue-900 text-white px-3 py-2 rounded-lg hover:bg-blue-700"
            >
              Next
            </motion.button>
          </Link>
        </motion.div>
      </motion.div>
      {showQuiz && (
        <QuizPopup onClose={() => setShowQuiz(false)} onComplete={handleQuizComplete} />
      )}
    </div>
  );
};

export default DataCollection;
